/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geonocities2Inputs */

const en_geonocities2 = /** @type {(inputs: Geonocities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No named places with activity in this window yet.`)
};

const de_geonocities2 = /** @type {(inputs: Geonocities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine benannten Orte mit Aktivität in diesem Zeitraum.`)
};

/**
* | output |
* | --- |
* | "No named places with activity in this window yet." |
*
* @param {Geonocities2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geonocities2 = /** @type {((inputs?: Geonocities2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geonocities2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geonocities2(inputs)
	return de_geonocities2(inputs)
});
export { geonocities2 as "geoNoCities" }